import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-success-falure',
  templateUrl: './success-falure.component.html',
  styleUrls: ['./success-falure.component.scss']
})
export class SuccessFalureComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';


  url = '';



  @Input() typeText: any='Email';
  @Input() failedRecords: any[] = [];

  successCount: number = 0;
  showFailedRecords: boolean = false;
displayedColumns: string[] = [];


  ngOnInit(): void {

    if (this.failedRecords.length > 0) {

       this.displayedColumns = [this.typeText, 'reason'];

      this.showFailedRecords = true;

      const failedArray = this.failedRecords;

       this.failedRecords = [];

      this.failedRecords = this.failedRecords;

      failedArray.forEach(failedItem => {
        // Each item is an object with waId as key and message as value
        Object.keys(failedItem).forEach(key => {
          this.failedRecords.push({
            key: key,
            reason: failedItem[key]
          });
        });
      });

    }
  }




  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    constructor(private router: Router) {
        this.url = this.router.url || '';
            this.router.events
              .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
              .subscribe(() => { this.url = this.router.url || ''; });
    }
}
